import React, { FC, useState } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { formatRoles, sameArrays } from '../../../../utils/user';
import CheckBoxListItem from '../../ManageEntities/List/CheckBoxListItem/CheckBoxListItem';
import UserDetailHeader from '../Header/UserDetailHeader';
import { IUserEditState } from '../utils';
import ConfirmationButtons from '../../../ConfirmationButtons/ConfirmationButtons';
import { APAS, Role } from '../../../../common/constants';
import CustomDialog from '../../../../common/components/CustomDialog';
import { formatDate } from '../../../../utils/common';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    list: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
  }),
);

interface Params {
  setOpenModal(open: boolean): void;
  userState: IUserEditState;
  setUserState: React.Dispatch<React.SetStateAction<IUserEditState>>;
}

const EditUserRoleModal: FC<Params> = (props) => {
  const { setOpenModal, userState, setUserState } = props;
  const classes = useStyles();

  const roles = userState.roles as Role[];
  const fullName = `${userState.firstName} ${
    userState.lastName ? userState.lastName : ''
  }`;

  const [selectedRoles, setSelectedRoles] = useState<Role[]>(roles);

  const handleClose = () => {
    setOpenModal(false);
  };

  const handleChangeRoles = (
    event: React.ChangeEvent<HTMLInputElement>,
    role: Role,
  ) => {
    if (event.target.checked) {
      if (!selectedRoles.includes(role)) {
        setSelectedRoles(selectedRoles.concat([role]));
      }
    } else {
      setSelectedRoles(selectedRoles.filter((roleItem) => roleItem !== role));
    }
  };

  const handleSave = () => {
    setUserState({
      ...userState,
      roles: selectedRoles,
    });
    setOpenModal(false);
  };

  const rolesNotChanged = sameArrays(roles, selectedRoles);

  return (
    <CustomDialog
      open
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      onClose={handleClose}
      closeAfterTransition
      actions={
        <ConfirmationButtons
          handleCancel={handleClose}
          handleConfirm={handleSave}
          disableConfirm={rolesNotChanged}
        />
      }>
      <UserDetailHeader
        avatarUrl={userState.avatarUrl}
        fullName={fullName}
        roles={roles}
        enseigneName={userState.userEnseigne?.name || ''}
        createdAt={formatDate(userState.createdAt)}
      />
      {Object.keys(Role).map((roleItem) => (
        <CheckBoxListItem
          id={roleItem}
          checked={selectedRoles.includes(roleItem as Role)}
          text={formatRoles(roleItem)}
          handleChange={handleChangeRoles}
          disabled={
            APAS.includes(roleItem as Role) || roleItem === Role.MANDATARY
          }
        />
      ))}
    </CustomDialog>
  );
};

export default EditUserRoleModal;
